<template>
	<div class="pipe-container">
		<div class="pipe-charts" ref="myEchart"></div>
		<div class="chart_data">
			<div class="line-data" v-for="(item,index) in ydata" :key='index'>
				<div class="line-radus">
					<span :class="'colorSpan'+(index+1)"></span>
					<span>{{item.name}}</span>
				</div>
				<div class="line-percent">{{(item.percentage*100).toFixed(2)}}%</div>
			</div>
		</div>
	</div>

</template>
<script>
  export default {
    data() {
        return {
            chart: null,
            option: {},
            color: [{color: "#29CC97", class: 'colorSpan1', value: '0~1占比：'},
                {color: "#4B7EFE", class: 'colorSpan2', value: '1~3占比：'},
                {color: "#5B6378", class: 'colorSpan3', value: '4~6占比：'},
                {color: "#FEC400", class: 'colorSpan4', value: '7~10占比：'},
                {color: "#636EFB", class: 'colorSpan5', value: '10+占比：'}
            ],
            ydata: [
                {
                    name: '0~1占比',
                    value: 18
                },
                {
                    name: '1~3占比',
                    value: 16
                },
                {
                    name: '4~6占比',
                    value: 15
                },
                {
                    name: '7~10占比',
                    value: 14
                },
                {
                    name: '10+占比',
                    value: 10
                },
            ]
        }
    },
    props: ['id', 'pipeGraphData'],
    watch: {
        pipeGraphData(val) {
            this.initChart();
        }
    },
    mounted() {
        this.initChart();
    },
    methods: {
      initChart() {
        let myChart = this.$echarts.init(this.$refs.myEchart);
        let color = ["#29CC97", "#4B7EFE", "#5B6378", "#FEC400", "#636EFB", "#19a755"];
        let xdata = ['0~1占比：', "1~3占比：", "4~6占比", "7~10占比", '10+占比'];
        let pipeGraphData = this.pipeGraphData;
        if (pipeGraphData && pipeGraphData.length > 0) {
          this.ydata.length = 0;
          pipeGraphData.forEach((item, i) => {
            let itemJson = {name: item.ageDate + '占比', value: item.num, percentage: item.percentage};
            this.ydata.push(itemJson);
          });
        }
        let ydata = this.ydata;
        let option = {
          backgroundColor: "rgba(255,255,255,1)",
          height: 420,
          title: [{
            text: '患者 | 初诊年龄',
            left: '1%',
            top: '2%',
            textStyle: {
              fontSize: '16px',
              fontFamily: 'PingFang SC',
              fontWeight: 400,
              color: 'rgba(51,51,51,1)'
            }
          }],
          color: color,
          series: [{
            type: 'pie',
            clockwise: false, //饼图的扇区是否是顺时针排布
            radius: ["60%", "80%"],
            center: ["50%", "50%"],
            avoidLabelOverlap: false,

            label: {
              normal: {
                show: false,
                position: 'center',
                formatter: '{text|{b}}\n{c} ({d}%)',
                rich: {
                  text: {
                    color: "#666",
                    fontSize: 12,
                    align: 'center',
                    verticalAlign: 'middle',
                  },
                  value: {
                    color: "#8693F3",
                    fontSize: 12,
                    align: 'center',
                    verticalAlign: 'middle',
                  },
                }
              },
              emphasis: {
                show: true,
                textStyle: {
                  fontSize: 12,
                }
              }
            },
            data: ydata
          }]
        };
        myChart.setOption(option)

        setTimeout(function () {
          myChart.on('mouseover', function (params) {
            if (params.name == ydata[0].name) {
              myChart.dispatchAction({
                type: 'highlight',
                seriesIndex: 0,
                dataIndex: 0
              });
            } else {
              myChart.dispatchAction({
                type: 'downplay',
                seriesIndex: 0,
                dataIndex: 0
              });
            }
          });

          myChart.on('mouseout', function (params) {
            myChart.dispatchAction({
              type: 'highlight',
              seriesIndex: 0,
              dataIndex: 0
            });
          });
          myChart.dispatchAction({
            type: 'highlight',
            seriesIndex: 0,
            dataIndex: 0
          });
        }, 1000);
        // 把配置和数据放这里
      }
    },
    beforeDestroy() {
      if (!this.chart) {
        return
      }
      this.chart.dispose();
      this.chart = null;
    }
  }
</script>
<style lang='scss' scoped>
	.pipe-container {
		display: flex;
		justify-content: center;
		align-items: center;
		background: #fff;
	}

	.pipe-charts {
		width: 50%;
		height: 450px;
		padding: 20px;
		/* border: 1px solid red; */
		margin: 0 auto;
	}

	.chart_data {
		width: 50%;
		padding: 35px 30px 0 60px;
	}

	.line-data {
		display: flex;
		justify-content: space-between;
		align-content: center;
		height: 50px;
		line-height: 50px;
		border-bottom: 1px dotted rgba(232, 232, 232, 1);
		border-radius: 1px;
		.line-radus {
			span:nth-child(1) {
				width: 10px;
				display: inline-block;
				height: 10px;
				border-radius: 50%;
			}
			span:nth-child(2) {
				font-size: 14px;
				margin-left: 10px;
				font-family: PingFang SC;
				font-weight: 400;
				color: rgba(164, 164, 164, 1);
			}
		}
		.line-percent {
			font-size: 14px;
			font-family: PingFang SC;
			font-weight: bold;
			color: rgba(164, 164, 164, 1);
		}
		.colorSpan1 {
			border: 2px solid #29CC97;
			color: #29CC97;
		}
		.colorSpan2 {
			border: 2px solid #4B7EFE;
			color: #4B7EFE;
		}
		.colorSpan3 {
			border: 2px solid #5B6378;
			color: #5B6378;
		}
		.colorSpan4 {
			border: 2px solid #FEC400;
			color: #FEC400;
		}
		.colorSpan5 {
			border: 2px solid #636EFB;
			color: #636EFB;
		}
		.colorSpan6 {
			border: 2px solid #19a755;
			color: #19a755;
		}

	}

</style>